// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__yiAuO","form":"styles_form__K6CzD","formActions":"styles_formActions__daMS-"};